import React from "react";
import AppBar from "material-ui/AppBar";
import Toolbar from "material-ui/Toolbar";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Grid from "material-ui/Grid";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import Drawer from "material-ui/Drawer";

class Content extends React.Component {
  state = {
    right: false
  };

  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open
    });
  };

  render() {
    const {
      classes,
      translate,
      children,
      open,
      ctx,
      toggle,
      drawerTitle,
      isSubTestView,
      fillHeight,
      scrollable
    } = this.props;
    const translateText = typeof translate === "function" ? translate : value => value;
    const centredClassName = `${isSubTestView ? classes.centred2 : classes.centred}${fillHeight ? ` ${classes.centredFill}` : ""}`;
    const wrapperClassName = `${classes.wrapper}${fillHeight ? ` ${classes.wrapperFill}` : ""}`;
    const contentClassName = `${classes.content}${fillHeight ? ` ${classes.contentFill}` : ""}`;
    const rootClassName = `${classes.root}${fillHeight ? ` ${classes.rootFill}` : ""}`;
    const gridItemClassName = fillHeight
      ? `${classes.gridItemFill}${scrollable ? ` ${classes.gridItemScroll}` : ""}`
      : undefined;
    const fillBodyClassName = `${classes.bodyFill}${scrollable ? ` ${classes.bodyFillScroll}` : ""}`;

    return (
      <div className={wrapperClassName}>
        <div className={centredClassName}>
          <div className={contentClassName}>
            {fillHeight ? (
              <div className={fillBodyClassName}>{children}</div>
            ) : (
              <Grid container spacing={24} className={rootClassName}>
                <Grid item xs={12} className={gridItemClassName}>
                  {children}
                </Grid>
              </Grid>
            )}
            <Drawer
              anchor="right"
              open={open}
              className={classes.contextMenu}
              onClose={() => toggle()}
            >
              <AppBar position="static">
                <Toolbar>
                  <Typography
                    type="title"
                    className={classes.flex}
                    color={"inherit"}
                  >
                    {drawerTitle
                      ? translateText(drawerTitle)
                      : translateText("select_columns")}
                  </Typography>
                  <Button
                    onClick={() => toggle()}
                    fab
                    mini
                    color={"accent"}
                    className={classes.white}
                  >
                    <Icon>close</Icon>
                  </Button>
                </Toolbar>
              </AppBar>
              <Grid container spacing={24} className={classes.root}>
                <Grid item>{ctx}</Grid>
              </Grid>
            </Drawer>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(Content);
